<!--
<div *ngIf="dataReady" class="graphs-container height-adjustment-graphs-container">
 <graph-filter-panel [selectedReport]="selectedReport" [externalData]="externalData" (refreshChart)="refreshChart($event)"></graph-filter-panel>
  <graph-menu-panel [selectedReport]="selectedReport" (selectChanged)="onReportSelected($event)" ></graph-menu-panel>
  <graph-area-panel [selectedReport]="selectedReport" [externalData]="externalData"></graph-area-panel>
</div>
-->
<!--
<div *ngIf="!dataReady">
  <ac-progress center="true"></ac-progress>
</div>
-->


<arm-layout *ngIf="dataReady"  [summaryTitle]="'Filters'" [menuTitle]="'Graphs'">
  <div menu>
    <graph-menu-panel [selectedReport]="selectedReport" (selectChanged)="onReportSelected($event)" ></graph-menu-panel>
  </div>
  <div main class="container">
    <graph-area-panel [selectedReport]="selectedReport" [externalData]="externalData"></graph-area-panel>
  </div>

  <div summary>
    <graph-filter-panel  [selectedReport]="selectedReport" [externalData]="externalData" (refreshChart)="refreshChart($event)"></graph-filter-panel>
  </div>
</arm-layout>
